import React, {useEffect, useState} from 'react';
import { Dialog,Box, Avatar} from '@mui/material';
import { styled } from '@mui/material/styles'; 
import BtnPrimary from "./PrimaryButton";
import BtnSecondary from "./SecondaryButton";
import FormField from './Formfield';
import GreenTick from "../assets/icons/greentick.png";
import RedCross from "../assets/icons/red-cross-filled.png";
import ErrorMsg from './ErrorMsg';
import { useNotify } from './NotificationProvider';

import { tokens } from "../theme";
const TextBox = styled(Box)({
    display: "block",
    textAlign:"center",
    fontWeight:"500",
    color:tokens.pendingText
});

/**
 * @param onDone  optional; called after the decision is actually recorded.
 *   `onClose` also fires on cancel, so a caller that needs to refresh cannot
 *   tell the two apart without this.
 */
function ActionDialog({type, open, onClose, reviewApi, id, text, onDone}) {

  const notify = useNotify();
  const [comment,setComment] = useState("");
  const [errorMsg,setErrorMsg] = useState("");

  useEffect(() => {
    if (!open) {
      setComment("");
      setErrorMsg("");
    }
  }, [open]);

  const handleYes = async () => {
    const Form = {
      status:type==="approve"?"Approved":"Rejected",
      reviewerComment:type==="approve"?"Approved":comment
   }
    try {
      const res = await reviewApi(Form, id);
      if(res.success){
        notify.success(type==="approve" ? "Approved successfully" : "Rejected successfully");
        onClose();
        if (onDone) onDone();
      }else{
        const message = res?.data?.message || res?.message;
        setErrorMsg(message);
        notify.error(message || "Action failed");
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width:"30%",
          borderRadius: "12px",
          boxShadow: "0 4px 12px -4px rgba(42,29,34,0.16)",
          padding: "1.5rem",
          display:"flex",
          flexDirection:"column",
          gap: "1.5rem"
        }
      }}
    >
        <Box sx={{display:"flex", width:"100%", justifyContent:"center", alignItems:"center"}}>
            <Avatar src={type==="approve"?GreenTick:RedCross} alt="icon" sx={{height:"3rem", width:"3rem"}}/>
        </Box>
        <TextBox>{text}</TextBox>
        {type==="reject"?
          <FormField
            type="text"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            fullwidth={true}
        />
        :null}
        <Box sx={{display:"flex",justifyContent:"center"}}>
            <ErrorMsg>
              {errorMsg}
            </ErrorMsg>
        </Box>
        <Box style={{display:"flex",justifyContent:"center", gap: "1.5rem", width:"100%"}}>
           <BtnPrimary onClick={handleYes} sx={{width:"6.25rem", borderRadius: '8px' }}>
                Yes
           </BtnPrimary>
           <BtnSecondary onClick={onClose} sx={{width:"6.25rem", borderRadius: '8px' }}>
                No
           </BtnSecondary>
        </Box>
    </Dialog>
  );
}

export default ActionDialog;

